import { render, staticRenderFns } from "./ParametersAccordion.vue?vue&type=template&id=28b20890&scoped=true&"
import script from "./ParametersAccordion.vue?vue&type=script&lang=ts&"
export * from "./ParametersAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b20890",
  null
  
)

export default component.exports